<script setup lang="ts">
import type { SelectValueProps } from 'reka-ui';
import { SelectValue } from 'reka-ui';

defineOptions({
    compatConfig: {
        MODE: 3,
    },
});

const props = defineProps<SelectValueProps>();
</script>

<template>
    <SelectValue
        data-slot="select-value"
        class="select-value mt-px"
        v-bind="props"
    >
        <slot></slot>
    </SelectValue>
</template>
